import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, MailCheck } from 'lucide-react';
import authService from '../services/authService';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await authService.forgotPassword(email.trim());
      setSent(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login" style={{ gridTemplateColumns: '1fr' }}>
      <main style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 'clamp(24px, 5vw, 64px)' }}>
        <form className="panel login-form" onSubmit={submit}>
          <div className="row" style={{ gap: 10 }}>
            <span className="brand-mark">iD</span>
            <span style={{ fontWeight: 600 }}>Inditech Document Hub</span>
          </div>

          {sent ? (
            <>
              <div className="empty__icon" style={{ background: 'var(--ok-bg)', color: 'var(--ok-fg)' }}>
                <MailCheck size={22} />
              </div>
              <div>
                <h2 style={{ fontSize: 22, marginBottom: 4 }}>Check your email</h2>
                <div className="muted" style={{ fontSize: 13.5, lineHeight: 1.6 }}>
                  If an Inditech account exists for <strong>{email}</strong>, we have sent a password reset link. It expires in 30 minutes.
                </div>
              </div>
              <Link to="/login" className="btn btn-s">
                <ArrowLeft size={15} /> Back to sign in
              </Link>
            </>
          ) : (
            <>
              <div>
                <h2 style={{ fontSize: 22, marginBottom: 4 }}>Reset your password</h2>
                <div className="muted" style={{ fontSize: 13.5 }}>
                  Enter your work email and we will send you a reset link.
                </div>
              </div>
              <div>
                <label className="lbl">Work email</label>
                <input className="in" type="email" placeholder="name@inditech.me" value={email} onChange={(e) => setEmail(e.target.value)} required />
              </div>
              <button type="submit" className="btn btn-p btn-lg" disabled={busy || !email.trim()}>
                {busy ? 'Sending…' : 'Send reset link'}
              </button>
              <div style={{ fontSize: 12.5 }}>
                <Link to="/login" style={{ fontWeight: 600 }}>
                  Back to sign in
                </Link>
              </div>
            </>
          )}
        </form>
      </main>
    </div>
  );
}
